import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class JobMode extends Cloneable {
    static TOUCH = new JobMode(0, "TOUCH");
    static AUTO = new JobMode(2, "AUTO");
    static CUSTOM = new JobMode(1, "CUSTOM");
    static TRADER = new JobMode(3, "TRADER");
    static FREE_WORKER = new JobMode(4, "FREE_WORKER");
    static DRAGON = new JobMode(5, "DRAGON");

    static _values = [
        JobMode.TOUCH,

        JobMode.AUTO,
        JobMode.CUSTOM,
        JobMode.TRADER,
        JobMode.FREE_WORKER,
        JobMode.DRAGON
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, JobMode.getValue(id));
        }, {
            beforeDeserialize: function (callback, value, parentValue) {
                if (parentValue["play"] === 1) {
                    callback(null, 2)
                } else {
                    callback(null, value)
                }
            }
        });
    }

    static getValues() {
        return JobMode._values;
    }

    static getValue(id) {
        let value = JobMode._values.find(v => v.id === id) || null;
        console.assert(value, "unknown value: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof JobMode) {
            return JobMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof JobMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new JobMode());
        } else if (target instanceof JobMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(JobMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});